var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-role-grid-wrapper',{attrs:{"title":_vm.title,"values":_vm.values,"on-open":_vm.onOpen,"on-add-role":_vm.onAddRole}})}
var staticRenderFns = []

export { render, staticRenderFns }